import { render, staticRenderFns } from "./tyyBusinessStatics.vue?vue&type=template&id=2f14e4f0&"
import script from "./tyyBusinessStatics.vue?vue&type=script&lang=js&"
export * from "./tyyBusinessStatics.vue?vue&type=script&lang=js&"
import style0 from "./tyyBusinessStatics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports